module.exports = __webpack_public_path__ + "images/right_top.png";